<script>
export default {
  name: 'ptoList',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    rejectRecord(id) {
      this.$emit('rejectRecord', id);
    },
    approveRecord(id) {
      this.$emit('approveRecord', id);
    },
    openDetailDialog(item) {
      this.$emit('details', item);
    },
  },
};
</script>

<template>
  <tr>
    <td @click="openDetailDialog(item)" style="cursor:pointer"><b> {{ item.adSoyad }}</b> 
    <br/>
    {{ item.pozisyon }} - {{item.santiye}} </td>
    <td> {{ item.izinTuru }} </td>
    <td> {{ item.izinSuresi }}</td>
    <td> {{ item.izinBaslangicTarihi|dateTimeView  }} </td>
    <td> {{ item.izinBitisTarihi|dateTimeView  }} </td>

    <td>
      <v-btn @click="rejectRecord(item.pfaaliyet)" color="darken-3" small icon fat text>
        <v-icon color="red">
          mdi-close
        </v-icon>
      </v-btn>
    </td>
    <td>
      <v-btn @click="approveRecord(item.pfaaliyet)" color="darken-3" small icon fat text>
        <v-icon color="success">
        mdi-check
      </v-icon>
      </v-btn>
    </td>
  </tr>
</template>
